import { render, staticRenderFns } from "./poptip.vue?vue&type=template&id=bf0810b0"
import script from "./poptip.vue?vue&type=script&lang=js"
export * from "./poptip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports